import { FieldType } from './types'

// Please do not migrate this part of the code to prevent circular dependencies
export const getFieldDefaultProperty = (fieldType: FieldType) => {
	switch (fieldType) {
		case FieldType.Flag:
			return null
		case FieldType.Currency:
			return {
				symbol: '$',
				precision: 2,
			}
		case FieldType.Percent:
		case FieldType.Number:
			return {
				precision: 0,
			}
		case FieldType.Text:
			return null
		case FieldType.NotSupport:
			return null
	}

	return null
}
